import type { AuthRepositoryPort, OnboardingInput } from "../ports/auth.repository.port";

export function onboardingUseCase(repository: AuthRepositoryPort, input: OnboardingInput) {
  if (!input.termsConsent || !input.dataProcessingConsent) {
    throw new Error("É necessário aceitar os termos e o processamento de dados.");
  }
  return repository.onboarding(input);
}
